/**
    Form Targets
    @readonly
    @enum {string}
*/
export var FORMTARGET;
(function (FORMTARGET) {
    FORMTARGET["SELF"] = "_self";
    FORMTARGET["BLANK"] = "_blank";
    FORMTARGET["PARENT"] = "_parent";
    FORMTARGET["TOP"] = "_top";
})(FORMTARGET || (FORMTARGET = {}));
;
